"use client";
import { Button, Col, Row, Image } from "antd";
import styles from "./index.module.scss";
import { RightOutlined } from "@ant-design/icons";
import lastServicePic from "@/assets/images/about/lastServicePic.svg";
import call from "@/assets/images/about/call.svg";
import { map } from "lodash";
import { registerUrl, onlineContactUrl } from "@/constants/api";
import {
  registers,
} from "@/constants/header";
export default function LastService({
  titList01,
  buttonText = "立即体验",
  btnLink = registerUrl,
}: {
  titList01?: string[];
  buttonText?: string;
  btnLink?: string;
}) {
  function goRegister() {
    window.open(registers, "_blank");
  }

  function goContact() {
      window.open(onlineContactUrl, "_blank");
    }

  return (
    <div className={styles.lastService}>
      <div className={styles.titleWrap}>
        <Image
          src={lastServicePic.src}
          className={styles.pic}
          preview={false}
          onDragStart={(e) => {
            e.preventDefault();
          }}
        />
        <Image
          src={call.src}
          className={styles.call}
          preview={false}
          onDragStart={(e) => {
            e.preventDefault();
          }}
        />
      </div>
      <div className={styles.btnWrap}>
        <button className={styles.registerBtn} onClick={goRegister}>
          申请试用
        </button>
        <button className={styles.callBtn} onClick={goContact}>
          <span>联系我们</span>
        </button>
      </div>
    </div>
  );
}
